module.exports = __webpack_public_path__ + "media/4x3/se-22333e71.svg";